import { requestAuth, request } from "common-frontend-components";
import { appConfig } from "../variables/appConfig";
export function callGetPostsAsync() {
    return request.get(`${appConfig.postsUrl}`)
        .then(posts => {
        posts.forEach((p) => { p.created = new Date(p.created); });
        posts.sort((a, b) => {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            // @ts-ignore
            return b.created - a.created;
        });
        return posts;
    });
}
export function callCreatePostAsync(post) {
    return requestAuth.post(`${appConfig.postsUrl}`, post)
        .then(i => { i.created = new Date(i.created); return i; });
}
export function callEditPostAsync(postId, post) {
    return requestAuth.patch(`${appConfig.postsUrl}/${postId}`, post)
        .then(i => { i.created = new Date(i.created); return i; });
}
export function callDeletePostAsync(postId) {
    return requestAuth.delete(`${appConfig.postsUrl}/${postId}`);
}
//# sourceMappingURL=posts.js.map